import { autoinject } from 'aurelia-framework';
import { pluck } from "rxjs/operators";
import { connectTo } from "aurelia-store";
import { applicationLogger } from "../../logging/logger";
import { IState } from "../../store/state";

@connectTo<IState>({
	target: 'applicationState',
	selector: {
		locationState: (store) => store.state.pipe(pluck('locationState'))
	}
})
@autoinject
export class NotificationRecipients {
  applicationState: IState;

  constructor() {
  }

  bind(bindingContext: any, overrideContext: any) {
  }

  attached() {
  }

  detached() {
  }
}